<template>
  <section>
    <v-layout v-if="user && business" pl-2 pt-2 pr-2 pb-2 justify-center row>
      <v-flex xs4 xl2 lg3>
        <v-layout column>
          <SimpleCard>
            <v-layout column>
              <v-flex xs12>
                <h3>{{user.name}}</h3>
                <p>
                  <a :href="'mailto:' + user.email">{{ user.email }}</a>
                </p>
                <p>
                  <a :href="'tel:' + formatNumber(user.contact_number) ">{{ user.contact_number }}</a>
                </p>
                <v-btn
                  style="margin-left: 0px;"
                  class="text-none"
                  flat
                  @click="showResetPassword = true"
                >
                  <v-icon left dark>security</v-icon>Reset Password
                </v-btn>
              </v-flex>
            </v-layout>
          </SimpleCard>
          <v-flex pt-2>
            <SimpleCard>
              <v-layout column>
                <v-flex pb-3>
                  <h3>Customer Options</h3>
                </v-flex>
                <a
                  target="_blank"
                  :href="'/bookings?contact_number=' + user.contact_number + '&name=' + user.name"
                >
                  <h4>View Bookings</h4>
                </a>
                <router-link to="/">
                  <h4>Users (TODO)</h4>
                </router-link>
                <router-link :to="`/corporateCustomer/edit/${business.id}`">
                  <h4>Update Details</h4>
                </router-link>
              </v-layout>
            </SimpleCard>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs8 xl5 lg4 pl-2>
        <SimpleCard>
          <PaymentCards :bookingForm="{ 'user' : user }" />
        </SimpleCard>
      </v-flex>
      <v-flex v-if=" mode == 'trips'" xs10 pl-2>
        <SimpleCard></SimpleCard>
      </v-flex>
      <ResetPassword
        :show="showResetPassword"
        :userID="user.id"
        :userName="user.name"
        @hideResetPassword="showResetPassword = false"
      />
    </v-layout>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">{{ snackbarMessage }}</v-snackbar>
  </section>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import ResetPassword from "@/components/customer/ResetPassword.vue";
import PaymentCards from "@/components/customer/PaymentCards.vue";
import { replaceStart } from "@/components/util/PhoneNumbers.js";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "corporate_customer",
  components: {
    SimpleCard,
    ResetPassword,
    PaymentCards
  },
  data: function() {
    return {
      mode: "trips",
      user: null,
      business: null,
      loading: true,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
      showResetPassword: false
    };
  },
  mounted: async function() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo: async function() {
      let self = this;
      let url = `${this.$store.state.apiUrl}/corporateCustomer/${this.$route.params.id}/get`;

      axios
        .get(url)
        .then(function(response) {
          if (!response.error) {
            if (response.data.user && response.data.business) {
              self.user = response.data.user;
              self.business = response.data.business;
            } else {
              self.snackbarMessage =
                "Error fetching corporate customer, no data";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            }
          } else {
            console.log(response.error);
            self.snackbarMessage =
              "Error fetching corporate customer: " + response.error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          }
          self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          self.snackbarMessage = error;
          self.snackbarColour = "error";
          self.snackbarShow = true;
          self.loading = false;
        });
    },
    formatNumber: function(number) {
      return replaceStart(number);
    }
  }
};
</script>

<style  lang="scss">
h4 {
  padding-top: 3px;
  padding-bottom: 3px;
}
</style>